import React, { useCallback } from 'react'
import { Select } from '@shopify/polaris'

const SelectComponent = (props) => {
  const handleChange = useCallback((newValue) => {
    if (props.onChange) props.onChange(props.name, newValue)
  }, [])

  return (
    <Select
      {...props}
      onChange={handleChange}
    />
  )
}

export default SelectComponent
